import { ABSOLUTE_MEASURE_TYPE } from 'shared/constants';
import { CustomizeText } from 'shared/types';
import {
  createFieldFormatPercentageFunction,
  createFieldFormatUnitFunction,
} from 'shared/utils';
import { useAppSelector } from 'state/store';

export const useDisplayFormattedValue = (precision?: number): CustomizeText => {
  const { measureType } = useAppSelector((state) => state.uiState);

  if (measureType === ABSOLUTE_MEASURE_TYPE) {
    return createFieldFormatUnitFunction(precision || 0);
  }

  return createFieldFormatPercentageFunction(precision || 2);
};
